import { basket } from '@redux/slices/basket';
import { useAppDispatch } from '@redux/store';
import * as React from 'react';
import S from './Background.styles';
const Background = () => {
    const dispatch = useAppDispatch();
    return React.createElement(S.Background, { "aria-hidden": true, onClick: closeCartOverlay });
    async function closeCartOverlay() {
        dispatch(basket.actions.setDrawerStatus('closed'));
    }
};
export default Background;
